import Chart from "./Chart.vue";
// @ts-ignore
export type { ChartElement, ProvideChart } from "./Chart.vue";

export default Chart;
